import { getToken, statesOptions } from "helper/common";
import {
    CLEAR_DISTRICT_LIST,
    SET_DISTRICT_FILTER_DATA,
    SET_DISTRICT_LIST,
    DISTRICT_CREATE_DIALOG_CLOSE,
    DISTRICT_CREATE_DIALOG_OPEN,
    DISTRICT_CREATE_ERROR,
    DISTRICT_CREATE_ERROR_CLEAR,
    DISTRICT_CREATE_PENDING,
    DISTRICT_EDIT_DIALOG_CLOSE,
    DISTRICT_EDIT_DIALOG_OPEN,
    DISTRICT_EDIT_ERROR,
    DISTRICT_EDIT_ERROR_CLEAR,
    DISTRICT_EDIT_PENDING,
    DISTRICT_FILTER_DIALOG_CLOSE,
    DISTRICT_FILTER_DIALOG_OPEN,
    DISTRICT_LIST_ERROR,
    DISTRICT_LIST_ERROR_CLEAR,
    DISTRICT_LIST_PENDING,
} from "./constants";
import agent from "store/service/agent";
import { openSnackbar } from "store/slices/snackbar";
import { trimmedValues } from "helper/trim";
import { encodeObjectValues } from "helper/encodeData";

//-----------------------------|| LIST ||---------------------------------------------------------------
export const setDistrictList = (districtList) => ({
    type: SET_DISTRICT_LIST,
    payload: { districtList }
});

export const clearDistrictList = () => ({
    type: CLEAR_DISTRICT_LIST,
});

export const districtListPending = () => ({
    type: DISTRICT_LIST_PENDING
});

export const districtListError = (errorMessage) => ({
    type: DISTRICT_LIST_ERROR,
    payload: { errorMessage }
});

export const districtListErrorClear = () => ({
    type: DISTRICT_LIST_ERROR_CLEAR
});

export const getDistrictList = (page, pageSize, sortOrder, sortDirection, filter) => (dispatch) => {
    const encodeFilters = encodeObjectValues({ ...filter })
    dispatch(districtListPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.districtConfiguration.getDistrictList(accessToken, page, pageSize, sortOrder, sortDirection, encodeFilters)
            .then((districtList) => {
                dispatch(setDistrictList(districtList));
                dispatch(districtListErrorClear());
                dispatch(districtEditErrorClear());
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error?.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(districtListError(message));
                }
                else {
                    dispatch(districtListError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| FILTER ||-------------------------------------------------------------
export const openDistrictFilterDialog = () => ({
    type: DISTRICT_FILTER_DIALOG_OPEN
});

export const closeDistrictFilterDialog = () => ({
    type: DISTRICT_FILTER_DIALOG_CLOSE
});

export const setDistrictFilteredData = (filter) => ({
    type: SET_DISTRICT_FILTER_DATA,
    payload: { filter },
});

//-----------------------------|| CREATE ||---------------------------------------------------------------
export const openDistrictCreateDialog = () => ({
    type: DISTRICT_CREATE_DIALOG_OPEN
});

export const closeDistrictCreateDialog = () => ({
    type: DISTRICT_CREATE_DIALOG_CLOSE
});

export const districtCreatePending = () => ({
    type: DISTRICT_CREATE_PENDING
});

export const districtCreateError = (errorMessage) => ({
    type: DISTRICT_CREATE_ERROR,
    payload: { errorMessage }
});

export const districtCreateErrorClear = () => ({
    type: DISTRICT_CREATE_ERROR_CLEAR
});

export const districtCreate = (formData, filter, paginationData) => (dispatch) => {
    const { page, pageSize, sortOrder, sortDirection } = paginationData || {};
    const dataToSend = trimmedValues({ ...formData })
    dispatch(districtCreatePending());
    return getToken(dispatch).then((accessToken) => {
        return agent.districtConfiguration.districtCreate(accessToken, dataToSend)
            .then(() => {
                dispatch(getDistrictList(page, pageSize, sortOrder, sortDirection, filter));
                dispatch(districtCreateErrorClear());
                dispatch(closeDistrictCreateDialog());
                dispatch(openSnackbar({
                    open: true,
                    message: 'District successfully created.',
                    variant: 'alert',
                    close: false
                }))
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(districtCreateError(message));
                }
                else {
                    dispatch(districtCreateError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

export const getStateOptionCreate = (search, selectedRegion, page, pageSize) => (dispatch) => {
    return getToken(dispatch).then((accessToken) => {
        return agent.farmRecords.getStateOptionCreate(accessToken, search, selectedRegion, page, pageSize)
            .then((stateList) => {
                const { value } = stateList || [];
                const options = statesOptions(value);
                return Promise.resolve(options);
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(openSnackbar({
                        open: true,
                        message: 'Something went wrong. Try again.',
                        variant: 'alert',
                        close: false
                    }))
                    return Promise.reject(message);
                }
                else {
                    const message = ":( Network Error";
                    dispatch(openSnackbar({
                        open: true,
                        message: 'Something went wrong. Try again.',
                        variant: 'alert',
                        close: false
                    }))
                    return Promise.reject(message);
                }
            })
    })
}

//-----------------------------|| EDIT ||---------------------------------------------------------------
export const openDistrictEditDialog = () => ({
    type: DISTRICT_EDIT_DIALOG_OPEN
});

export const closeDistrictEditDialog = () => ({
    type: DISTRICT_EDIT_DIALOG_CLOSE
});

export const districtEditPending = () => ({
    type: DISTRICT_EDIT_PENDING
});

export const districtEditError = (errorMessage) => ({
    type: DISTRICT_EDIT_ERROR,
    payload: { errorMessage }
});

export const districtEditErrorClear = () => ({
    type: DISTRICT_EDIT_ERROR_CLEAR
});

export const districtEdit = (formData, page, pageSize, sortOrder, sortDirection, filter) => (dispatch) => {
    const dataToSend = trimmedValues({ ...formData })
    dispatch(districtEditPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.districtConfiguration.districtEdit(accessToken, dataToSend)
            .then(() => {
                dispatch(getDistrictList(page, pageSize, sortOrder, sortDirection, filter));
                dispatch(districtEditErrorClear());
                dispatch(openSnackbar({
                    open: true,
                    message: 'District details successfully updated.',
                    variant: 'alert',
                    close: false
                }))
                return Promise.resolve(true);
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error?.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(districtEditError(message));
                }
                else {
                    dispatch(districtEditError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}
